export default "__VITE_ASSET__0087b858__"